import React, { Component } from 'react';
import '../App.css';
/* global $ */
/* global grecaptcha */
/* global grec_ready */

export default class Register extends Component {
  componentDidMount(){
    let grec_promise = new Promise((resolve, reject) => {
      function check_grec() {
        if (!grec_ready) {
          setTimeout(check_grec, 50);
          return;
        }
        // grecaptcha is ready
        resolve();
      }
      check_grec();
    });
    grec_promise.then(() => {
      widget_id = grecaptcha.render('surer', {
          'sitekey' : '6LdDyl8UAAAAAMmSSzFS29e-Jda0oneqA30CieP4',
          'theme' : 'light'
        });  
    });
    $('#reg_modal').on('hidden.bs.modal', function () {
      $('#reg_pass').val('');
      $('#reg_pass2').val('');
      $('#reg_email').val('');
      $('#reg_uname').val('');
      grecaptcha.reset(widget_id);
      document.querySelector('#age_check').checked = false;
      document.querySelector('#courage_check').checked = false;
      if (window.location.hash.substring(1) === 'register')
        window.history.pushState("", document.title, window.location.pathname
                                                        + window.location.search);
    })
  }
  
  reg_submit() {
    let firebase = this.props.app_state.firebase;
    // allow only numbers, letters, and underscore
    let check_key = $('#reg_uname').val().replace(/\W/g, '').toLowerCase();
    if (check_key.length === 0) {
      $('.alert').fadeOut();
      return $('#alert_danger').text('Invalid username').fadeIn().delay(1800).fadeOut();
    }
    if (document.querySelector('#click_me').checked) {
      return;
    }
    let new_email = $('#reg_email').val();
    let email_last_char = new_email[new_email.length - 1];
    if (new_email.length < 1 || new_email.indexOf('@') < 1 
                             || email_last_char === '.'
                             || new_email.includes(' ')) {
      $('.alert').fadeOut();
      return $('#alert_danger').text('Invalid email address').fadeIn().delay(1800).fadeOut();
    }
    if ($('#reg_pass').val().replace(/[a-zA-Z]/g, '').length === 0) {
      $('.alert').fadeOut();
      return $('#alert_danger').text('Password must contain at least one number').fadeIn().delay(2200).fadeOut();
    }
    if ($('#reg_pass').val().length < 6) {
      $('.alert').fadeOut();
      return $('#alert_danger').text('Password must have at least 6 characters').fadeIn().delay(2200).fadeOut();
    }
    if ($('#reg_pass').val() !== $('#reg_pass2').val()) {
      $('.alert').fadeOut();
      return $('#alert_danger').text('Passwords do not match').fadeIn().delay(1800).fadeOut();
    }
    if (!document.querySelector('#age_check').checked) {
      $('.alert').fadeOut();
      return $('#alert_danger').text('Please verify your age & agree to our terms of conditions').fadeIn().delay(2100).fadeOut();
    }
    $('#alert_working').fadeIn().delay(5000).fadeOut();
    
    let wants_courage = document.querySelector('#courage_check').checked;
    let token = grecaptcha.getResponse(widget_id);
    $.post('https://us-central1-minusthenegative-1fd3c.cloudfunctions.net/cap_reg', 
          {'token': token,
           'new_name': $('#reg_uname').val(),
           'new_email': new_email,
           'wants_courage': wants_courage})
      .then((res) => {
        let from_server = JSON.parse(res);
        if (from_server['success'] === false) {
          grecaptcha.reset(widget_id);
          $('.alert').fadeOut();
          
          if (from_server['error-codes'].includes('invalid-username'))
            return $('#alert_danger').text('Invalid username').fadeIn().delay(1800).fadeOut();
          
          if (from_server['error-codes'].includes('email-taken'))
            return $('#alert_danger').text('Email address already in use').fadeIn().delay(1800).fadeOut();
          
          if (from_server['error-codes'].includes('invalid-email'))
            return $('#alert_danger').text('Invalid email address').fadeIn().delay(1800).fadeOut();
          
          return $('#alert_danger').text('Recaptcha Failed').fadeIn().delay(1800).fadeOut();
        }
        
        let new_key = from_server['new_key'];
        
        firebase.auth()
          .createUserWithEmailAndPassword(new_email, $('#reg_pass').val())
            .then((user_cred) => {
              firebase.auth().signInWithEmailAndPassword(new_email, $('#reg_pass').val())
                .then(() => {
                  let user = user_cred.user;
                  firebase.database().ref('main/pending_users/'+new_key)
                    .update({
                      'firebase_id': user.uid
                    })
                    .then(() => {
                      $('#reg_modal').modal('hide');
                      $('.alert').fadeOut();
                      $('#reg_alert').fadeIn();
                      grecaptcha.reset(widget_id);
                      return;
                    })
                    .catch((error) => {
                      grecaptcha.reset(widget_id);
                      $('.alert').fadeOut();
                      $('#alert_danger').text(error.message).fadeIn().delay(1800).fadeOut();
                      console.log(error);
                      return;
                    });
                })
                .catch((error) => {
                  console.log(error);
                });
            })
            .catch(function(error) {
              grecaptcha.reset(widget_id);
              $('.alert').fadeOut();
              $('#alert_danger').text(error.message).fadeIn().delay(1800).fadeOut();
              console.log(error);
              return;
            });
      });
  }
  
  render() {
    return (
      <div id="reg_modal" className="modal fade" tabindex="-1" role="dialog">
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Register</h5>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            
            <t style={{'margin-top': '15px'}}>Username</t>
            <input id="reg_uname"  placeholder="Enter your username" 
                                   className="form-control" name="username"></input>
            <t style={{'margin-top': '15px'}}>E-mail Address</t>
            <input id="reg_email" type="email"
                                    placeholder="Enter your email address" 
                                    className="form-control" name="email"></input>
            <t style={{'margin-top': '15px'}}>Password</t>
            <input id="reg_pass" placeholder="Enter your password" 
                                   className="form-control" type="password"
                                   name="password"></input>
            <t style={{'margin-top': '15px'}}>Confirm Password</t>
            <input id="reg_pass2" style={{'margin-bottom': '25px'}}
                                   placeholder="Re-enter your password" 
                                   className="form-control" type="password"></input>
            <label className="container">I am 18 years of age or older &amp; I have read and agree to the terms of conditions
              <input id="age_check" type="checkbox"/>
              <span className="checkmark"></span>
            </label>
            <label className="container">I would like to receive weekly encouragement emails
              <input id="courage_check" type="checkbox"/>
              <span className="checkmark"></span>
            </label>
            
            <div id="surer" className="g-recaptcha"></div>
            <input id="click_me" type="checkbox" style={{'display': 'none'}}/>
            
            <div style={{'margin-top': '20px'}} className="modal-footer">
              <button onClick={this.reg_submit.bind(this)} type="button" className="btn btn-dark">Register</button>
              <button type="button" className="btn btn-outline-danger" data-dismiss="modal">Cancel</button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
let widget_id;


// WEBPACK FOOTER //
// ./src/components/Register.js